import { render, staticRenderFns } from "./subsriberInfoAdditional.vue?vue&type=template&id=70c738fe&"
import script from "./subsriberInfoAdditional.vue?vue&type=script&lang=js&"
export * from "./subsriberInfoAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports